// English strings of the controls (decision D13: English first). Another language
// adds a file next to this one with the same shape.

export const strings = {
  dockLabel: "Engine controls",
  audio: {
    start: "Start audio",
    stop: "Stop audio",
    starting: "Starting…",
    failed: "Audio failed: try again",
    hint: "Browsers play sound only after you click or press a key.",
  },
  ignition: { label: "Ignition", on: "On", off: "Off" },
  starter: { label: "Starter", hint: "Hold to crank" },
  throttle: { label: "Throttle" },
  volume: { label: "Volume", mute: "Mute", unmute: "Unmute" },
  rpm: { label: "Engine speed", unit: "rpm", none: "–" },
  phase: { stopped: "Stopped", cranking: "Cranking", running: "Running", off: "Audio off" },
  views: { label: "View", none: "Custom" },
  link: { copy: "Copy link", copied: "Link copied", failed: "Copy the address from the address bar" },
} as const;

/** Keyboard shortcuts, as the Keys panel lists them. Keys are KeyboardEvent.key values. */
export const shortcuts = [
  { keys: ["a"], label: "A", action: "Start or stop the audio" },
  { keys: ["i"], label: "I", action: "Switch the ignition on or off" },
  { keys: ["s"], label: "S (hold)", action: "Crank the starter" },
  { keys: ["ArrowUp"], label: "↑", action: "Open the throttle 5 %" },
  { keys: ["ArrowDown"], label: "↓", action: "Close the throttle 5 %" },
  { keys: ["0"], label: "0", action: "Close the throttle" },
  { keys: ["m"], label: "M", action: "Mute or unmute" },
] as const;
